/** @jsxImportSource @emotion/react */
import React from 'react'
import * as styles from '../index.styles'
import Provider from '../../../context/NotificationFCMContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'
import {FCMForm, FCMPreview} from '../../../components/templates'

const { index, contentManagement, manageNotificationsFCM } = breadcrumbItems

const SendNotification: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageNotificationsFCM]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <FCMForm />
        </div>
        <div css={styles.right}>
          <FCMPreview />
        </div>
      </div>
    </Provider>
  )
}

export default SendNotification
